// App.tsx
import { lazy, Suspense, type Component } from "solid-js";
import { Route, Router } from "@solidjs/router";
import Protected from "./components/protected";
import { AuthProvider } from "./context/auth";
import { Toaster } from "solid-toast";
import { routes, flattenRoutes } from "./routes";
import Layout from "./layout";
import { ErrorBoundary } from "solid-js";

const Login = lazy(() => import("./pages/login"));
const ForbiddenPage = lazy(() => import("./pages/401"));
const NotFoundPage = () => <div>Not Found Page</div>;
const ErrorPage = lazy(() => import("./pages/500"));
const AuthUser = lazy(() => import("./Auth"));

const App: Component = () => {
  return (
    <ErrorBoundary
      fallback={(err) => {
        console.dir(err);
        return <ErrorPage message={err.message} />;
      }}
    >
      <AuthProvider>
        <Router>
          <Suspense
            fallback={
              <div class="h-screen flex items-center justify-center">
                Loading...
              </div>
            }
          >
            {/* Public route */}
            <Route path="/login" component={Login} />
            <Route path="/401" component={ForbiddenPage} />
            <Route path="/auth" component={AuthUser} />
            {/* Protected + pakai layout */}
            <Route path="/" component={Protected}>
              {flattenRoutes(routes)?.map((r) => (
                <Route
                  path={r.pathname}
                  component={() => (
                    <Layout page={r.component!} permission={r.permission} />
                  )}
                />
              ))}
            </Route>
            <Route path="*" component={NotFoundPage} />
          </Suspense>
        </Router>
        <Toaster
          containerStyle={{ "z-index": 9999 }}
          toastOptions={{ position: "top-right" }}
          gutter={15}
        />
      </AuthProvider>
    </ErrorBoundary>
  );
};

export default App;
